import React from 'react';
import { Container } from '@material-ui/core';
import Card from 'src/views/register/Card';
import TelegramLoginButton from 'react-telegram-login';

export const TELEGRAM_BOT = process.env.REACT_APP_BOTNAME;

const RegisterView = ({ telegramCodeExist}) => {
  const loginResponse = response => {
    telegramCodeExist(response.id);
  };
 
  return (
    <Container>
      <Card
        title="Step 2: Login with Telegram"
        description="Will the telegram account, you can receive notification and report from telegram"
      >
        <TelegramLoginButton
          dataOnauth={loginResponse}
          botName={TELEGRAM_BOT}
          usePic={false}
          cornerRadius="3"
          style={{ width: '100%' }}
        />
      </Card>
    </Container>
  );
};

export default RegisterView;
